import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {omit, noop} from 'lodash'
import ReactSlider, {Handle} from 'rc-slider'

// eslint-disable-next-line
import Tooltip from 'rc-tooltip'

import './Scrubbler.scss'
import formatSeconds from './formatSeconds'

const ScrubblerHandle = (props) => (
  <ScrubblerTooltipTrigger {...props}>
    <Handle {...omit(props, ['dragging', 'index'])} />
  </ScrubblerTooltipTrigger>
)

class Scrubbler extends Component {

  static propTypes = {
    currentTime: PropTypes.number.isRequired,
    totalTime: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
  }

  state = {
    // When dragging of slider is released outside of the iframe it is contained in,
    // the slider enters a constant dragging mode.
    // to prevent this, we rerender the slider by increasing this key.
    sliderRemountKey: 0
  }

  mouseEntersDocument = event => {
    const leftMouseButtonClicked = event.which === 1
    if (leftMouseButtonClicked){
      return
    }
    this.setState({sliderRemountKey: this.state.sliderRemountKey + 1})
  }

  componentDidMount(){
    document.addEventListener('mouseenter', this.mouseEntersDocument)
  }

  componentWillUnmount(){
    document.removeEventListener('mouseenter', this.mouseEntersDocument)
  }

  render() {
    const {currentTime, totalTime, onChange, disabled} = this.props
    const {sliderRemountKey} = this.state

    return (
      <div data-id="progress-bar" styleName="scrubbler">
        <ReactSlider
          key={sliderRemountKey}
          handle={ScrubblerHandle}
          ariaLabelForHandle="Play Slider"
          min={0}
          max={totalTime}
          step={0.05}
          value={currentTime}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    )
  }
}

class ScrubblerTooltipTrigger extends Component {

  state = {tooltipVisible: false}
  clickFocus = noop

  showTooltip = () => this.setState({tooltipVisible: true})
  hideTooltip = () => this.setState({tooltipVisible: false})

  render() {
    const {value, index, dragging, children} = this.props
    return (
      <div onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip}>
        <Tooltip
          prefixCls="scrubbler-handle-tooltip"
          overlay={formatSeconds(value)}
          visible={this.state.tooltipVisible || dragging}
          align={{
            offset: [0, -7]
          }}
          dataId="test-scrubbler-tooltip"
          placement="top"
          key={index}
          destroyTooltipOnHide={true}
        >
          {children}
        </Tooltip>
      </div>
    )
  }
}

export default Scrubbler
